import React from 'react';
import { RouteObject } from 'react-router-dom';

import { CommunityLogin } from './pages/CommunityLogin/CommunityLogin';
import { App } from './pages/App';
import { ErrorPage } from './pages/ErrorPage';
import { CoursePage, loader as courseLoader } from './pages/CoursePage';
import { LessonPage, loader as lessonLoader } from './pages/LessonPage';
import { HomePage } from './pages/HomePage';
import { CatalogPage, loader as catalogLoader } from './pages/CatalogPage';
import { LearningPathPage, loader as learningPathLoader } from './pages/LearningPathPage';
import { FeedbackPage } from './pages/App/FeedbackPage';
import { MyLearningPage, loader as myLearningLoader } from './pages/MyLearningPage';
import { loader as certPrepLoader, CertificatePreparationPage } from './pages/hubs/CertificatePreparationPage';
import {
  loader as learningPathsHubLoader,
  LearningPathPage as LearningPathsHubPage,
} from './pages/hubs/LearningPathPage';
import { RoleBasedPage, loader as roleBasedHubLoader } from './pages/hubs/RoleBasedPage';
import { CertificationPage, loader as certificationLoader } from './pages/hubs/CertificationPage';
import { LiveTrainingPage } from './pages/landings/LiveTrainingPage';
import { RelatedTopicCollectionPage, loader as topicLoader } from './pages/collections/RelatedTopicCollectionPage';
import { CertificationDetailPage, loader as certDetailLoader } from './pages/CertificationDetailPage';
import { RoleBasedCollectionPage, loader as roleLoader } from './pages/collections/RoleBasedCollectionPage';
import {
  loader as certPrepCollectionLoader,
  CertificatePreparationCollectionPage,
} from './pages/collections/CertificationPreparation';
import {
  LandingType,
  ContentHubType,
  CollectionType,
  AlternativeContentHubType,
  AlternativeCollectionType,
} from './constants';
import {
  getCatalogUrl,
  getCertificationUrl,
  getCollectionUrl,
  getCourseUrl,
  getHubUrl,
  getLandingUrl,
  getLessonUrl,
  getMyLearningUrl,
  getPathUrl,
  LANDING_URL_PATH,
  withPrefix,
} from './utils/getUrl';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/community-login',
        element: <CommunityLogin />,
      },
      {
        path: getCatalogUrl(),
        element: <CatalogPage />,
        loader: catalogLoader,
      },
      {
        path: getCourseUrl(':courseId'),
        element: <CoursePage />,
        loader: courseLoader,
      },
      {
        path: getCourseUrl(':courseId', ':pathId'),
        element: <CoursePage />,
        loader: courseLoader,
      },
      {
        path: getCourseUrl(':courseId', '', true),
        element: <FeedbackPage />,
      },
      {
        path: getCourseUrl(':courseId', ':pathId', true),
        element: <FeedbackPage />,
      },
      {
        path: getPathUrl(':pathId'),
        element: <LearningPathPage />,
        loader: learningPathLoader,
      },
      {
        path: getMyLearningUrl(':status'),
        element: <MyLearningPage />,
        loader: myLearningLoader,
      },
      {
        path: withPrefix(getCourseUrl(':courseId', ':pathId'), getHubUrl(ContentHubType.LEARNING_PATHS)),
        element: <CoursePage />,
        loader: courseLoader,
      },
      ...[
        getLessonUrl({ lessonSlug: ':lessonId' }),
        getLessonUrl({ courseSlug: ':courseId', lessonSlug: ':lessonId' }),
        getLessonUrl({ pathSlug: ':pathId', courseSlug: ':courseId', lessonSlug: ':lessonId' }),
        withPrefix(
          getLessonUrl({
            pathSlug: ':pathId',
            courseSlug: ':courseId',
            lessonSlug: ':lessonId',
          }),
          getHubUrl(ContentHubType.LEARNING_PATHS),
        ),
      ].map((path) => ({
        path,
        element: <LessonPage />,
        loader: lessonLoader,
      })),
      {
        path: withPrefix(getPathUrl(':pathId'), getHubUrl(ContentHubType.LEARNING_PATHS)),
        element: <LearningPathPage />,
        loader: learningPathLoader,
      },
      {
        path: getHubUrl(ContentHubType.LEARNING_PATHS),
        element: <LearningPathsHubPage />,
        loader: learningPathsHubLoader,
      },
      {
        path: getCollectionUrl(CollectionType.TOPIC, ':topicId'),
        element: <RelatedTopicCollectionPage />,
        loader: topicLoader,
      },
      ...[
        getLandingUrl(LandingType.LIVE_TRAINING),
        withPrefix(getLandingUrl(LandingType.LIVE_TRAINING), LANDING_URL_PATH),
      ].map((path) => ({
        path,
        element: <LiveTrainingPage />,
      })),
      ...[getHubUrl(ContentHubType.CERTIFICATIONS), getCertificationUrl()].map((path) => ({
        path,
        element: <CertificationPage />,
        loader: certificationLoader,
      })),
      ...[
        withPrefix(getLandingUrl(LandingType.CERTIFICATION_DETAIL, ':certificationId'), LANDING_URL_PATH),
        getCertificationUrl(':certificationId'),
      ].map((path) => ({
        path,
        element: <CertificationDetailPage />,
        loader: certDetailLoader,
      })),
      ...[getHubUrl(AlternativeContentHubType.CERT_PREP), getHubUrl(ContentHubType.CERT_PREP)].map((path) => ({
        path,
        element: <CertificatePreparationPage />,
        loader: certPrepLoader,
      })),
      ...[getHubUrl(AlternativeContentHubType.ROLE_BASED), getHubUrl(ContentHubType.ROLE_BASED)].map((path) => ({
        path,
        element: <RoleBasedPage />,
        loader: roleBasedHubLoader,
      })),
      ...[
        getCollectionUrl(AlternativeCollectionType.CERT_PREP, ':certPrepId'),
        getCollectionUrl(CollectionType.CERT_PREP, ':certPrepId'),
      ].map((path) => ({
        path,
        element: <CertificatePreparationCollectionPage />,
        loader: certPrepCollectionLoader,
      })),
      ...[
        getCollectionUrl(AlternativeCollectionType.ROLE_BASED, ':roleId'),
        getCollectionUrl(CollectionType.ROLE_BASED, ':roleId'),
      ].map((path) => ({
        path,
        element: <RoleBasedCollectionPage />,
        loader: roleLoader,
      })),
    ],
  },
];
